(() => {
  const root = document.querySelector('.cc:not(.cc-goods-root)');
  if (!root || root.dataset.alive === 'true') return;
  root.dataset.alive = 'true';

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const carVideo = root.querySelector('.cc-black-clipper__video');
  if (carVideo) {
    const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
    const syncCarMotion = () => {
      if (motionPreference.matches || document.hidden) carVideo.pause();
      else carVideo.play().catch(() => {});
    };
    motionPreference.addEventListener('change', syncCarMotion);
    document.addEventListener('visibilitychange', syncCarMotion);
    syncCarMotion();
  }

  const quotes = [...root.querySelectorAll('.cc-quote')];
  const dots = [...root.querySelectorAll('.cc-testimonial__dots button')];
  let quoteIndex = 0;
  const showQuote = (index) => {
    quoteIndex = index;
    quotes.forEach((quote, i) => quote.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };
  dots.forEach((dot, i) => dot.addEventListener('click', () => showQuote(i)));
  if (!reduced && quotes.length > 1) setInterval(() => showQuote((quoteIndex + 1) % quotes.length), 7000);

  /* Frequency is merchant-controlled in the Theme Editor and remains fixed. */
  root.querySelector('[data-radio-toggle]')?.addEventListener('click', (event) => {
    const drawer = root.querySelector('.cc-radio-drawer');
    if (!drawer) return;
    drawer.hidden = !drawer.hidden;
    event.currentTarget.textContent = drawer.hidden ? 'TUNE IN →' : 'TUNED IN · 93.3 FM';
  });

  if (!reduced) {
    let ticking = false;
    const drift = () => {
      const vh = innerHeight;
      root.querySelectorAll('[data-drift]').forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < vh) {
          const amount = Number(element.dataset.drift || 7);
          const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
          element.style.setProperty('--drift', `${progress * amount}px`);
        }
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(drift); } }, { passive: true });
    drift();
  }
})();
